const SELLING_PLAN_ID = 2944270594;

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// custom cookies setup
function getCookie(name) {
  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  );
  return matches ? decodeURIComponent(matches[1]) : null;
}

function setCookie(name, value, hours) {
  let expires = '';
  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

async function clearCart() {
  const response = await fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error('There was a problem clearing the cart');
  }
  return response.json();
}

window.clearCart = clearCart;

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        const widget = document.querySelector('.kl_reviews__star_rating_widget');
        const summaryDiv = document.querySelector('.kl_reviews__summary__stars__count');
        if (
          (widget && !widget.classList.contains('modified')) ||
          (summaryDiv && !summaryDiv.classList.contains('modified'))
        ) {
          if (widget && !widget.classList.contains('modified')) modifyWidget(widget);
          if (summaryDiv && !summaryDiv.classList.contains('modified') && savedLabelText) modifySummaryDiv(summaryDiv);
          if (
            (!widget || widget.classList.contains('modified')) &&
            (!summaryDiv || summaryDiv.classList.contains('modified'))
          ) {
            observer.disconnect();
          }
        }
      }
    });
  });
  function modifyWidget(widget) {
    // Extract the rating value, remove " stars", and round to one decimal place
    const originalRating = parseFloat(widget.getAttribute('aria-label').split(',')[0].trim().replace(' stars', ''));
    const roundedRating = Math.round(originalRating * 10) / 10;
    const ratingText = roundedRating.toFixed(1);

    // Create a new element for the rating
    const ratingElement = document.createElement('span');
    ratingElement.className = 'kl-rating-value';
    ratingElement.textContent = ratingText;

    // Insert the rating before the stars
    widget.insertBefore(ratingElement, widget.firstChild);

    // Change "ratings" to "reviews" and hide the original text
    const labelElement = widget.querySelector('.kl_reviews__star_rating_widget__label');
    if (labelElement) {
      const reviewsCount = labelElement.textContent.split(' ')[0];
      savedLabelText = reviewsCount + ' reviews';
      labelElement.textContent = savedLabelText;
      labelElement.style.display = 'none';
    }

    // Create a new element for "reviews" text
    const reviewsElement = document.createElement('span');
    reviewsElement.className = 'kl-reviews-text';
    reviewsElement.textContent = savedLabelText;
    widget.appendChild(reviewsElement);

    // Mark the widget as modified to prevent multiple modifications
    widget.classList.add('modified');
  }
  // Header Sticky
  function headerSticky() {
    const header = document.querySelector('.js-header');
    if (!header) return;

    const mainWrapper = document.querySelector('#root');
    const headerHeight = header.offsetHeight;
    const sticky = header.offsetTop;
    // mainWrapper.style.paddingTop = `${headerHeight}px`;

    window.addEventListener('scroll', () => {
      if (window.pageYOffset > sticky) {
        header.classList.add('m-sticky');
      } else {
        header.classList.remove('m-sticky');
      }
    });

    // workaround: remove padding-bottom after preview bar is loaded
    window.setTimeout(() => {
      let previewBar = document.getElementById('preview-bar-iframe');
      if (previewBar) {
        document.documentElement.style.removeProperty('padding-bottom');
      }
    }, 2000);
  }
  headerSticky();
  // END Header Sticky

  observer.observe(document.body, { childList: true, subtree: true });
});

// Products Carousel Component
class ProductsCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarousel();
  }

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {}

  get slidesPerViewMobile() {
    return this.getAttribute('slides-per-view-mobile') || 2.5;
  }

  get slidesPerViewTablet() {
    return this.getAttribute('slides-per-view-tablet') || 3.5;
  }

  get slidesPerViewDesktop() {
    return this.getAttribute('slides-per-view-desktop') || 5.5;
  }

  get spaceBetween() {
    return this.getAttribute('space-between') || 30;
  }

  get loop() {
    return this.getAttribute('loop') === 'true' || false;
  }

  initCarousel() {
    const swiperContainer = this.querySelector('.swiper');
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: 6,
      loop: this.loop,
      direction: 'horizontal',
      allowTouchMove: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewTablet,
          spaceBetween: this.spaceBetween,
        },
        992: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: this.spaceBetween,
        },
        1801: {
          slidesPerView: 6,
          spaceBetween: this.spaceBetween,
        },
      },
    });
  }
}

customElements.define('products-carousel', ProductsCarousel);

class CardsCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarouselDesktop();
    this.initCarouselMobile();
  }

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {}

  get slidesPerViewMobile() {
    return this.getAttribute('slides-per-view-mobile') || 1.5;
  }

  get spaceBetweenMobile() {
    return this.getAttribute('space-between-mobile') || 10;
  }

  initCarouselDesktop() {
    const swiperContainer = this.querySelector('.swiper--desktop');
    const swiper = new Swiper(swiperContainer, {
      effect: 'cards',
      cardsEffect: {
        perSlideOffset: 14,
        perSlideRotate: 0,
        slideShadows: false,
      },
      grabCursor: true,
      centeredSlides: true,
      loop: this.loop,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
  initCarouselMobile() {
    const swiperContainer = this.querySelector('.swiper--mobile');
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: this.spaceBetweenMobile,
      loop: this.loop,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('cards-carousel', CardsCarousel);

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.events();
  }

  events() {
    this.querySelectorAll('.js-product-card-add-to-cart').forEach((button) => {
      button.addEventListener('click', (event) => this.addToCart(event));
    });
  }

  async addToCart(e, quantity = 1) {
    const btn = e.currentTarget;
    const btnText = btn.querySelector('.js-product-card-add-to-cart-text');
    const oldText = btnText.innerText;
    btnText.innerText = 'Mixing your magna...';
    const productId = btn.dataset.productId;
    let items = [
      {
        id: productId,
        quantity: quantity,
      },
    ];

    const sellingPlanId = SELLING_PLAN_ID;
    const url = '/cart/add.js';
    const cart_drawer = document.querySelector('cart-drawer');
    const sections = cart_drawer.getSectionsToRender().map((section) => section.id);

    if (btn.dataset.subscription === 'true') {
      items = [
        {
          id: productId,
          quantity: quantity,
          selling_plan: sellingPlanId,
        },
      ];
    }

    try {
      if (this.addToCartType !== 'drawer') {
        await clearCart();
      }

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: sections,
        }),
      });
      if (!response.ok) {
        throw new Error('There was a problem with the request');
      }

      if (window.location.host.includes('drinkmagna')) {
        window.dataLayer.push({
          event: 'add_to_cart',
          items,
        });
      }

      const json = await response.json();

      if (this.addToCartType === 'drawer') {
        cart_drawer.renderContents(json);
        // cart_drawer.open();
      } else {
        document.location.href = '/cart/checkout';
      }
    } catch (e) {
      console.error(e.message);
      return null;
    } finally {
      btnText.innerText = oldText;
    }
  }
  async addToCartBackup(e, quantity = 1) {
    const btn = e.currentTarget;
    const btnText = btn.querySelector('.js-product-card-add-to-cart-text');
    btnText.innerText = 'Mixing your magna...';
    const productId = btn.dataset.productId;
    const cart_drawer = document.querySelector('cart-drawer');
    const url = '/cart/add.js';
    const sections = cart_drawer.getSectionsToRender().map((section) => section.id);
    const items = [
      {
        id: productId,
        quantity: quantity,
      },
    ];
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: sections,
        }),
      });
      if (!response.ok) {
        throw new Error('There was a problem with the request');
      }

      const json = await response.json();
      cart_drawer.renderContents(json);
      cart_drawer.open();
    } catch (e) {
      console.error(e.message);
      return null;
    } finally {
      btnText.innerText = 'Add to Cart';
    }
  }

  disconnectedCallback() {}

  get addToCartType() {
    return this.getAttribute('add-to-cart-type') || 'drawer';
  }
}
customElements.define('product-card', ProductCard);

class MarqueeText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarousel();
  }

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {}

  get direction() {
    return this.getAttribute('direction') === 'right';
  }

  get scrollSpeed() {
    return this.getAttribute('scroll-speed') || 4000;
  }

  initCarousel() {
    const swiperContainer = this.querySelector('.swiper');
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      speed: this.scrollSpeed,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: this.direction,
        pauseOnMouseEnter: true,
      },
      allowTouchMove: false,
    });
  }
}
customElements.define('marquee-text', MarqueeText);

class MediaSlider extends HTMLElement {
  constructor() {
    super();

    this.SELECTORS = {
      pagination: '.js-media-carousel-pagination',
    };
  }

  connectedCallback() {
    this.init();
    this.initCarousel();
  }

  disconnectedCallback() {
    this.swiper.destroy(true, true);
    this.destroyEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Init
   */
  init() {
    this.filters = document.querySelectorAll(`${this.filtersSelector} button`);
    this.currentFilter =
      [...this.filters].find((filter) => filter.classList.contains('m-active'))?.dataset.filter || 'featured';
    this.slides = this.querySelectorAll('[data-filter]');
    this.initCarousel();
    this.events();

    setTimeout(() => {
      this.applyFilters();
      this.querySelector(this.SELECTORS.pagination).classList.remove('hidden');
    }, 100);
  }

  /**
   * Events
   */
  events() {
    this.filters.forEach((filter) => {
      filter.addEventListener('click', (event) => this.handleFilterClick(event));
    });
  }

  /**
   * Destroy events
   */
  destroyEvents() {
    this.filters.forEach((filter) => {
      filter.removeEventListener('click', (event) => this.handleFilterClick(event));
    });
  }

  /**
   * Handle filter click
   */
  handleFilterClick(event) {
    const filterEl = event.currentTarget;
    const filterId = filterEl.dataset.filter;

    this.filters.forEach((filter) => {
      filter.classList.remove('m-active');
    });

    filterEl.classList.add('m-active');
    this.currentFilter = filterId;
    this.applyFilters();
  }

  /**
   * Apply filters to the slides
   */
  applyFilters() {
    if (this.currentFilter === 'all') {
      this.slides.forEach((slide) => {
        slide.classList.remove('non-swiper-slide');
        slide.classList.add('swiper-slide');
      });
    } else if (this.currentFilter === 'featured') {
      this.slides.forEach((slide, idx) => {
        if (idx < this.featuredAmount) {
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
        } else {
          slide.classList.add('non-swiper-slide');
          slide.classList.remove('swiper-slide');
          slide.removeAttribute('style');
        }
      });
    } else {
      this.slides.forEach((slide) => {
        if (slide.dataset.filter !== this.currentFilter) {
          slide.classList.add('non-swiper-slide');
          slide.classList.remove('swiper-slide');
          slide.removeAttribute('style');
        } else {
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
        }
      });
    }

    if (this.swiper) {
      this.swiper.destroy();
    }
    this.initCarousel();
  }

  /**
   * Init carousel
   */
  initCarousel() {
    const swiperContainer = this.querySelector('.swiper');
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: this.spaceBetweenMobile,
      loop: this.loop,
      direction: 'horizontal',
      allowTouchMove: true,
      // If we need pagination
      pagination: {
        el: this.SELECTORS.pagination,
        clickable: true,
        dynamicBullets: this.dynamicPagination,
        dynamicMainBullets: 6,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewTablet,
          spaceBetween: this.spaceBetweenTablet,
        },

        1200: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: this.spaceBetweenDesktop,
        },
      },
    });
  }

  get slidesPerViewMobile() {
    return this.getAttribute('slides-per-view-mobile') || 2;
  }

  get slidesPerViewTablet() {
    return this.getAttribute('slides-per-view-tablet') || 3;
  }

  get slidesPerViewDesktop() {
    return this.getAttribute('slides-per-view-desktop') || 3;
  }

  get spaceBetweenMobile() {
    return this.getAttribute('space-between-mobile') || 10;
  }

  get spaceBetweenTablet() {
    return this.getAttribute('space-between-tablet') || 20;
  }

  get spaceBetweenDesktop() {
    return this.getAttribute('space-between-desktop') || 26;
  }

  get loop() {
    return this.getAttribute('loop') === 'true' || false;
  }

  get filtersSelector() {
    return this.getAttribute('filters-selector') || '.js-media-carousel-filter';
  }

  get featuredAmount() {
    return Number(this.getAttribute('featured-amount')) || 5;
  }

  get dynamicPagination() {
    return this.getAttribute('dynamic-pagination') === 'true' || false;
  }
}

customElements.define('media-slider', MediaSlider);

class MediaSliderVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.playButton.addEventListener('click', () => this.playStopVideo());
  }

  disconnectedCallback() {
    this.playButton.removeEventListener('click', () => this.playStopVideo());
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  get video() {
    return this.querySelector('[data-video-player]');
  }

  get playButton() {
    return this.querySelector('[data-play-button]');
  }

  playStopVideo() {
    if (this.video.paused) {
      this.video.play();
      this.playButton.classList.add('m-transparent');
    } else {
      this.video.pause();
      this.playButton.classList.remove('m-transparent');
    }
  }
}

customElements.define('media-slider-video', MediaSliderVideo);

class PageHeader extends HTMLElement {
  constructor() {
    super();
    this.SELECTORS = {
      navToggler: '.js-nav-toggler',
      mobileNav: '.js-mobile-nav',
      megaMenu: '.js-shop-megamenu',
      megaMenuMobile: '.js-shop-megamenu-mobile',
      megaMenuOverlay: '.js-shop-megamenu-overlay',
      megaMenuClose: '.js-shop-megamenu-close',
      megaMenuTrigger: '.js-shop-megamenu-trigger',
      megaMenuTriggerMobile: '.js-shop-megamenu-trigger-mobile',
    };

    this.CLASSES = {
      active: 'm-active',
      expanded: 'm-expanded',
      overflowHidden: 'overflow-hidden',
      megaMenuOpen: 'm-megamenu-open',
    };

    this.isExpanded = false;
    this.desktopBreakpoint = 992;
    this.isMegaMenuOpen = false;
  }

  /**
   * Connected callback
   */
  connectedCallback() {
    this.debounce = window.debounce;

    if (!this.debounce) {
      console.error('Page header: Debounce is not defined');
    }

    this.navToggler = this.querySelector(this.SELECTORS.navToggler);
    this.mobileNav = this.querySelector(this.SELECTORS.mobileNav);
    this.body = document.querySelector('body');
    this.megaMenu = document.querySelector(this.SELECTORS.megaMenu);
    this.megaMenuMobile = this.megaMenu;
    this.megaMenuOverlay = this.megaMenu ? this.megaMenu.querySelector(this.SELECTORS.megaMenuOverlay) : null;
    this.megaMenuCloseButtons = this.megaMenu
      ? this.megaMenu.querySelectorAll(this.SELECTORS.megaMenuClose)
      : [];
    this.desktopTriggers = this.querySelectorAll(this.SELECTORS.megaMenuTrigger);
    this.mobileTriggers = this.querySelectorAll(this.SELECTORS.megaMenuTriggerMobile);

    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.events();

    this.initMegaMenu();
  }

  /**
   * Disconnected callback
   */
  disconnectedCallback() {
    this.destroyEvents();
  }

  /**
   * Attribute changed callback
  /**
   * Events
   */
  events() {
    this.handleNavTogglerClick = (event) => {
      event.preventDefault();
      this.showMobileNav();
    };
    this.navToggler.addEventListener('click', this.handleNavTogglerClick);
    window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 200));
  }

  /**
   * Destroy events
   */
  destroyEvents() {
    this.navToggler.removeEventListener('click', this.handleNavTogglerClick);
    window.removeEventListener('resize', this.debounce(this.handleResize.bind(this), 200));
  }

  /**
   * Hide mobile nav
   */
  hideMobileNav() {
    this.isExpanded = false;
    this.navToggler.classList.remove(this.CLASSES.expanded);
    this.body.classList.remove(this.CLASSES.overflowHidden);

    if (this.megaMenuMobile) {
      this.closeMegaMenuMobile();
    }
  }

  /**
   * Show mobile nav
   */
  showMobileNav() {
    this.isExpanded = true;
    this.navToggler.classList.add(this.CLASSES.expanded);
    this.body.classList.add(this.CLASSES.overflowHidden);

    if (this.megaMenuMobile) {
      this.openMegaMenuMobile();
    }
  }

  /**
   * Close mobile nav when window is resized to desktop
   */
  handleResize() {
    if (window.innerWidth > this.desktopBreakpoint) {
      this.isExpanded = false;
      this.navToggler.classList.remove(this.CLASSES.expanded);
      this.body.classList.remove(this.CLASSES.overflowHidden);
      if (window.innerWidth >= this.desktopBreakpoint) {
        this.closeMegaMenuDesktop();
      } else {
        this.closeMegaMenuMobile();
      }
    }
  }

  /**
   * Megamenu
   */
  initMegaMenu() {
    if (!this.megaMenu) return;

    this.desktopTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => this.openMegaMenuDesktop(trigger));
      trigger.addEventListener('mouseleave', () => this.scheduleMegaMenuClose());
      trigger.addEventListener('focusin', () => this.openMegaMenuDesktop(trigger));
    });

    if (this.megaMenuOverlay) {
      this.megaMenuOverlay.addEventListener('mouseenter', () => this.openMegaMenuDesktop());
      this.megaMenuOverlay.addEventListener('click', () => {
        if (window.innerWidth >= this.desktopBreakpoint) {
          this.closeMegaMenuDesktop();
        }
      });
    }

    this.megaMenu.addEventListener('mouseenter', () => this.clearMegaMenuCloseTimeout());
    this.megaMenu.addEventListener('mouseleave', () => this.scheduleMegaMenuClose());

    this.megaMenuCloseButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (window.innerWidth >= this.desktopBreakpoint) {
          this.closeMegaMenuDesktop();
        } else {
          this.hideMobileNav();
        }
      });
    });

    this.mobileTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.openMegaMenuMobile(trigger);
      });
    });

    document.addEventListener('keydown', this.handleDocumentKeydown);
    document.addEventListener('click', this.handleDocumentClick);
  }

  openMegaMenuDesktop(trigger = null) {
    if (window.innerWidth < this.desktopBreakpoint) return;
    this.clearMegaMenuCloseTimeout();
    this.isMegaMenuOpen = true;
    this.megaMenu.classList.add(this.CLASSES.active);
    this.megaMenu.setAttribute('aria-hidden', 'false');
    this.body.classList.add(this.CLASSES.megaMenuOpen);

    this.desktopTriggers.forEach((el) => {
      el.setAttribute('aria-expanded', 'true');
    });
  }

  scheduleMegaMenuClose() {
    this.clearMegaMenuCloseTimeout();
    this.megaMenuCloseTimeout = window.setTimeout(() => {
      if (window.innerWidth >= this.desktopBreakpoint) {
        this.closeMegaMenuDesktop();
      }
    }, 150);
  }

  clearMegaMenuCloseTimeout() {
    if (this.megaMenuCloseTimeout) {
      window.clearTimeout(this.megaMenuCloseTimeout);
      this.megaMenuCloseTimeout = null;
    }
  }

  closeMegaMenuDesktop() {
    if (!this.megaMenu) return;
    this.clearMegaMenuCloseTimeout();
    this.isMegaMenuOpen = false;
    this.megaMenu.classList.remove(this.CLASSES.active);
    this.megaMenu.setAttribute('aria-hidden', 'true');
    this.body.classList.remove(this.CLASSES.megaMenuOpen);

    this.desktopTriggers.forEach((el) => {
      el.setAttribute('aria-expanded', 'false');
    });
  }

  openMegaMenuMobile(trigger = null) {
    if (!this.megaMenuMobile) return;
    this.isMegaMenuOpen = true;
    this.megaMenu.classList.add(this.CLASSES.active);
    this.megaMenuMobile.classList.add(this.CLASSES.active);
    this.megaMenu.setAttribute('aria-hidden', 'false');
    this.megaMenuMobile.setAttribute('aria-hidden', 'false');
    this.body.classList.add(this.CLASSES.overflowHidden);

    this.mobileTriggers.forEach((el) => {
      el.setAttribute('aria-expanded', 'true');
    });
  }

  closeMegaMenuMobile() {
    if (!this.megaMenuMobile) return;

    this.isMegaMenuOpen = false;

    this.megaMenuMobile.classList.remove(this.CLASSES.active);
    this.megaMenuMobile.setAttribute('aria-hidden', 'true');
    this.megaMenu.classList.remove(this.CLASSES.active);
    this.megaMenu.setAttribute('aria-hidden', 'true');

    // Also hide the mobile nav container when megamenu is closed (e.g. via X)
    if (this.mobileNav) {
      this.isExpanded = false;
      this.mobileNav.classList.remove(this.CLASSES.active);
    }

    if (this.navToggler) {
      this.navToggler.classList.remove(this.CLASSES.expanded);
    }

    this.body.classList.remove(this.CLASSES.overflowHidden);

    this.mobileTriggers.forEach((el) => {
      el.setAttribute('aria-expanded', 'false');
    });
  }

  handleDocumentKeydown(event) {
    if (!this.isMegaMenuOpen) return;
    if (event.code.toUpperCase() === 'ESCAPE') {
      if (window.innerWidth >= this.desktopBreakpoint) {
        this.closeMegaMenuDesktop();
      } else {
        this.closeMegaMenuMobile();
      }
    }
  }

  handleDocumentClick(event) {
    if (!this.isMegaMenuOpen || !this.megaMenu) return;
    if (!this.megaMenu.contains(event.target) && !event.target.closest(this.SELECTORS.megaMenuTrigger)) {
      if (window.innerWidth >= this.desktopBreakpoint) {
        this.closeMegaMenuDesktop();
      }
    }
  }
}

customElements.define('page-header', PageHeader);

class CommunitySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarousel();
  }

  disconnectedCallback() {
    this.swiper.destroy(true, true);
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Init carousel
   */
  initCarousel() {
    const swiperContainer = this.querySelector('.swiper');
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: this.spaceBetweenMobile,
      loop: this.loop,
      direction: 'horizontal',

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewTablet,
          spaceBetween: this.spaceBetweenTablet,
        },

        1200: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: this.spaceBetweenDesktop,
        },
      },
    });
  }

  get slidesPerViewMobile() {
    return this.getAttribute('slides-per-view-mobile') || 2;
  }

  get slidesPerViewTablet() {
    return this.getAttribute('slides-per-view-tablet') || 3;
  }

  get slidesPerViewDesktop() {
    return this.getAttribute('slides-per-view-desktop') || 3;
  }

  get spaceBetweenMobile() {
    return this.getAttribute('space-between-mobile') || 10;
  }

  get spaceBetweenTablet() {
    return this.getAttribute('space-between-tablet') || 20;
  }

  get spaceBetweenDesktop() {
    return this.getAttribute('space-between-desktop') || 26;
  }

  get loop() {
    return this.getAttribute('loop') === 'true' || false;
  }
}

customElements.define('community-slider', CommunitySlider);

class AnimatedValues extends HTMLElement {
  constructor() {
    super();
    this.SELECTORS = {
      itemNumber: '.js-animate-value',
    };
    this.hasAnimated = false;
  }

  connectedCallback() {
    this.events();
  }

  disconnectedCallback() {
    this.destroyEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Events
   */
  events() {
    if (!this.animation) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startAnimation();
            this.hasAnimated = true;

            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    observer.observe(this);
  }

  /**
   * Start animation
   */
  startAnimation() {
    this.querySelectorAll(this.SELECTORS.itemNumber).forEach((el) => {
      this.animateValue(el, 0, Number(el.textContent), this.animationSpeed);
    });
  }

  /**
   * Destroy events
   */
  destroyEvents() {}

  /**
   * Animate value
   * @param {HTMLElement} el - The element to animate
   * @param {number} start - The starting value
   * @param {number} end - The ending value
   * @param {number} duration - The duration of the animation
   */
  animateValue(el, start, end, duration) {
    let startTimestamp = null;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      el.innerHTML = Math.floor(progress * (end - start) + start);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }

  get animation() {
    return this.getAttribute('animation') === 'true' || false;
  }

  get animationSpeed() {
    return this.getAttribute('animation-speed') || 1000;
  }
}

customElements.define('animated-values', AnimatedValues);

class CompareBrands extends HTMLElement {
  constructor() {
    super();
    this.SELECTORS = {
      item: '.js-compare-brands-item',
    };
    this.CLASSES = {
      active: 'm-active',
    };
    this.hasAnimated = false;
  }

  connectedCallback() {
    this.events();
  }

  disconnectedCallback() {
    this.destroyEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Events
   */
  events() {
    if (!this.animation) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startAnimation();
            this.hasAnimated = true;

            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    observer.observe(this);
  }

  /**
   * Start animation
   */
  startAnimation() {
    this.querySelectorAll(this.SELECTORS.item).forEach((el) => {
      el.classList.add(this.CLASSES.active);
    });
  }

  /**
   * Destroy events
   */
  destroyEvents() {}

  get animation() {
    return this.getAttribute('animation') === 'true' || false;
  }

  get animationSpeed() {
    return this.getAttribute('animation-speed') || 1000;
  }
}

customElements.define('compare-brands', CompareBrands);

class ExpertsSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarousel();
  }

  disconnectedCallback() {
    this.swiper.destroy(true, true);
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Init carousel
   */
  initCarousel() {
    const swiperContainer = this.querySelector('.swiper');
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: this.spaceBetweenMobile,
      loop: this.loop,
      direction: 'horizontal',

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewTablet,
          spaceBetween: this.spaceBetweenTablet,
        },

        1200: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: this.spaceBetweenDesktop,
        },
      },
    });
  }

  get slidesPerViewMobile() {
    return this.getAttribute('slides-per-view-mobile') || 2;
  }

  get slidesPerViewTablet() {
    return this.getAttribute('slides-per-view-tablet') || 3;
  }

  get slidesPerViewDesktop() {
    return this.getAttribute('slides-per-view-desktop') || 3;
  }

  get spaceBetweenMobile() {
    return this.getAttribute('space-between-mobile') || 10;
  }

  get spaceBetweenTablet() {
    return this.getAttribute('space-between-tablet') || 20;
  }

  get spaceBetweenDesktop() {
    return this.getAttribute('space-between-desktop') || 26;
  }

  get loop() {
    return this.getAttribute('loop') === 'true' || false;
  }
}

customElements.define('experts-slider', ExpertsSlider);

class FlavorHighlight extends HTMLElement {
  constructor() {
    super();

    this.SELECTORS = {
      button: '.js-flavor-highlight-button',
    };
  }

  connectedCallback() {
    this.initCarousel();
  }

  disconnectedCallback() {
    this.swiper.destroy(true, true);
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Init carousel
   */
  initCarousel() {
    const buttons = document.querySelectorAll(this.SELECTORS.button);
    const swiperContainer = this.querySelector('.swiper');
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      noSwiping: true,
      direction: 'horizontal',
      effect: this.effect,
    });

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((button) => {
          button.classList.remove('m-active');
        });

        button.classList.add('m-active');
        this.swiper.slideTo(button.dataset.index);
      });
    });
  }

  get effect() {
    return this.getAttribute('effect') || 'fade';
  }
}

customElements.define('flavor-highlight', FlavorHighlight);

class IngredientsGrid extends HTMLElement {
  constructor() {
    super();

    this.SELECTORS = {
      button: '.js-tab-button',
      content: '.js-tab-content',
      ingredientCard: '.js-ingredient-card',
    };
    this.activeTab = null;
    this.tabButtons = null;
    this.tabContents = null;
  }

  connectedCallback() {
    this.init();
    this.events();
  }

  disconnectedCallback() {
    this.destroyEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Init
   */
  init() {
    this.tabButtons = [...this.querySelectorAll(this.SELECTORS.button)];
    this.tabContents = [...this.querySelectorAll(this.SELECTORS.content)];

    this.setActiveTab(this.tabButtons[0].dataset.tabId);
  }

  /**
   * Events
   */
  events() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.setActiveTab(button.dataset.tabId);
      });
    });

    [...document.querySelectorAll(this.SELECTORS.ingredientCard)].forEach((ingredientCard) => {
      ingredientCard.addEventListener('click', (event) => {
        const modalBody = ingredientCard.querySelector('.js-ingredient-card-modal-body');
        const ingredientJson = ingredientCard.querySelector('.js-ingredient-card-modal-body-json');
        const ingredient = JSON.parse(ingredientJson.textContent);

        document.dispatchEvent(
          new CustomEvent('ctr:open-modal', {
            detail: { ingredientCard: modalBody, data: ingredient },
          })
        );
      });
    });
  }

  /**
   * Destroy events
   */
  destroyEvents() {}

  /**
   * Set active tab
   * @param {string} tabId - The ID of the tab to set active
   */
  setActiveTab(tabId) {
    this.resetTabs();

    this.tabButtons.find((button) => button.dataset.tabId === tabId).classList.add('m-active');
    this.tabContents.find((content) => content.dataset.tabId === tabId).classList.add('m-active');
  }

  resetTabs() {
    this.tabButtons.forEach((button) => {
      button.classList.remove('m-active');
    });

    this.tabContents.forEach((content) => {
      content.classList.remove('m-active');
    });
  }
}

customElements.define('ingredients-grid', IngredientsGrid);

class CtrModal extends HTMLElement {
  constructor() {
    super();

    this.SELECTORS = {
      body: '.js-modal-body',
      ingredientBody: '.js-modal-ingredient-body',
      close: '.js-modal-close',
      overlay: '.js-modal-overlay',
      modal: '.js-modal',
      image: '[data-image]',
      title: '[data-title]',
      description: '[data-description]',
      country: '[data-country]',
      density: '[data-density]',
      other: '[data-other]',
      information: '[data-information]',
    };
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroyEvents();
  }

  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Init
   */
  init() {
    this.events();
  }

  /**
   * Events
   */
  events() {
    this.querySelector(this.SELECTORS.close).addEventListener('click', () => {
      this.closeModal();
    });

    this.querySelector(this.SELECTORS.overlay).addEventListener('click', () => {
      this.closeModal();
    });

    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeModal());

    document.addEventListener('ctr:open-modal', (event) => {
      this.openModalByIngredientCard(event.detail.ingredientCard, event.detail.data);
    });
  }

  /**
   * Destroy events
   */
  destroyEvents() {}

  openModal() {
    this.querySelector(this.SELECTORS.modal).classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  openModalByIngredientCard(ingredientCard, data) {
    this.querySelector(this.SELECTORS.body).classList.add('hidden');
    const ingredientBody = this.querySelector(this.SELECTORS.ingredientBody);
    const descriptionEl = ingredientBody.querySelector(this.SELECTORS.description);
    const titleEl = ingredientBody.querySelector(this.SELECTORS.title);
    const imageEl = ingredientBody.querySelector(this.SELECTORS.image);

    ingredientBody.classList.remove('hidden');
    imageEl.src = data.image;
    titleEl.textContent = data.name || '';
    titleEl.classList.toggle('hidden', !data.name);
    descriptionEl.textContent = data.description || '';
    descriptionEl.parentElement.classList.toggle('hidden', !data.description);

    ingredientBody.querySelectorAll('[data-column]').forEach((el) => {
      const column = el.dataset.column;

      el.textContent = data[column] || '';
      el.parentElement.classList.toggle('hidden', !data[column]);
    });
    this.openModal();
  }

  closeModal() {
    this.querySelector(this.SELECTORS.modal).classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('ctr-modal', CtrModal);
